import type { OrderInvoiceStore } from './interfaces'

export const getters = {
  isLoading: (state: OrderInvoiceStore): OrderInvoiceStore['loading'] => state.loading,
  isPreviewLoading: (state: OrderInvoiceStore): OrderInvoiceStore['previewLoading'] => state.previewLoading,
  getSaved: (state: OrderInvoiceStore): OrderInvoiceStore['saved'] => state.saved,
  getDraft: (state: OrderInvoiceStore): OrderInvoiceStore['draft'] => state.draft,
  getInvoices: (state: OrderInvoiceStore): OrderInvoiceStore['invoices'] => state.invoices,
  hasInvoices: (state: OrderInvoiceStore): boolean => state.invoices.length > 0,
  getPreview: (state: OrderInvoiceStore): OrderInvoiceStore['preview'] => state.preview,
  getPreviewState: (state: OrderInvoiceStore): OrderInvoiceStore['previewState'] => state.previewState,
}
